import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TimeoutService {

  static setTimeout(timeoutFunction, timeoutInterval) {
    window.setTimeout(timeoutFunction, timeoutInterval);
  }
}
